
import GenratePopover from './genrate-popover.vue'
export default {
  components: {
    GenratePopover
  },
  props: {
    title: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    rows: {type: [String, Number], default: '2', required: false},
    maxlength: {type: Number, default: 0, required: false},
    description: {type: String, required: false, default: ''},
    parent: {type: Node, default: document.body},
    can_add: {type: Boolean, required: true}
  },
  emits: ['replace', 'append'],
  data() {
    return {
      generated_text: '',
      error: undefined
    }
  },
  methods: {
    onGenerated(value) {
      this.generated_text = value
    },
    onReplace() {
      this.$emit('replace', this.generated_text)
      this.$refs.popover.hide()
    },
    onAppend(){
      this.$emit('append', this.generated_text)
      this.$refs.popover.visible = false
    }
  }
}
